"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var AccountsReceivableLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsReceivableLineResource, _super);
    function AccountsReceivableLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsReceivableLineResource.endpoint = '/lines/ar';
    AccountsReceivableLineResource.MODEL_NAME = 'accountsreceivableline';
    return AccountsReceivableLineResource;
}(lines_1.BaseLineResource));
exports.default = AccountsReceivableLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/ar/lines.js
// module id = 67ko
// module chunks = 0